/** Données géographiques pour la cascade Pays → Ville → Région. */

import { State, City } from 'country-state-city';

// Les 24 gouvernorats tunisiens avec leur code ISO-3166-2 (partie après « TN- »),
// car country-state-city a des noms anglais et des entrées manquantes pour la Tunisie.
const TUNISIA_GOVERNORATES = [
  { name: 'Tunis', stateCode: '11' },
  { name: 'Ariana', stateCode: '12' },
  { name: 'Ben Arous', stateCode: '13' },
  { name: 'Manouba', stateCode: '14' },
  { name: 'Nabeul', stateCode: '21' },
  { name: 'Zaghouan', stateCode: '22' },
  { name: 'Bizerte', stateCode: '23' },
  { name: 'Béja', stateCode: '31' },
  { name: 'Jendouba', stateCode: '32' },
  { name: 'Le Kef', stateCode: '33' },
  { name: 'Siliana', stateCode: '34' },
  { name: 'Kairouan', stateCode: '41' },
  { name: 'Kasserine', stateCode: '42' },
  { name: 'Sidi Bouzid', stateCode: '43' },
  { name: 'Sousse', stateCode: '51' },
  { name: 'Monastir', stateCode: '52' },
  { name: 'Mahdia', stateCode: '53' },
  { name: 'Sfax', stateCode: '61' },
  { name: 'Gafsa', stateCode: '71' },
  { name: 'Tozeur', stateCode: '72' },
  { name: 'Kébili', stateCode: '73' },
  { name: 'Gabès', stateCode: '81' },
  { name: 'Médenine', stateCode: '82' },
  { name: 'Tataouine', stateCode: '83' },
];

// country-state-city ne référence aucune ville pour Nabeul (TN-21).
const NABEUL_CITIES = [
  'Nabeul', 'Hammamet', 'Dar Chaâbane El Fehri', 'Béni Khiar', 'Korba',
  'Menzel Temime', 'Kélibia', 'El Haouaria', 'Soliman', 'Grombalia',
  'Bou Argoub', 'Menzel Bouzelfa', 'Béni Khalled', 'Takelsa',
  'Dar Allouche', 'El Mida', 'Hammam Ghezèze',
];

const cleanStateName = (name) =>
  (name || '').replace(/\s+(Governorate|Wilaya|Prefecture)$/i, '');

const dedupeByName = (list) => {
  const seen = new Set();
  return list.filter((v) => {
    if (seen.has(v.name)) return false;
    seen.add(v.name);
    return true;
  });
};

/**
 * Options du champ « Ville » pour un pays donné.
 * Retourne des objets { name, stateCode } : stateCode sert à charger les régions.
 * Liste vide → le formulaire affiche un champ texte libre.
 */
export function getVilleOptions(countryCode) {
  if (!countryCode || countryCode === 'other') return [];
  if (countryCode === 'TN') return TUNISIA_GOVERNORATES;

  const states = State.getStatesOfCountry(countryCode) || [];
  if (states.length) {
    return dedupeByName(
      states.map((s) => ({ name: cleanStateName(s.name), stateCode: s.isoCode }))
    );
  }
  // Pays sans découpage administratif : on propose directement les villes.
  return dedupeByName(
    (City.getCitiesOfCountry(countryCode) || []).map((c) => ({ name: c.name, stateCode: '' }))
  );
}

/**
 * Options du champ « Région » pour la ville choisie.
 * Liste vide → le formulaire affiche un champ texte libre (optionnel).
 */
export function getRegionOptions(countryCode, villeName) {
  if (!countryCode || !villeName) return [];
  const ville = getVilleOptions(countryCode).find((v) => v.name === villeName);
  if (!ville || !ville.stateCode) return [];
  if (countryCode === 'TN' && ville.stateCode === '21') return NABEUL_CITIES;
  return Array.from(
    new Set((City.getCitiesOfState(countryCode, ville.stateCode) || []).map((c) => c.name))
  );
}
